<!--
 * @Date: 2023-12-29 11:18:32
 * @Author: jm
 * @LastEditTime: 2024-08-06 15:44:17
 * @LastEditors: jm
 * @FilePath: \gamegenialjoycom\src\components\TopBar.vue
 * @Description: 
-->
<template>
  <div class="top">
    <a class="header" href="home.html">
      <img src="../assets/images/icon.png" alt="" class="icon" />
      <img src="../assets/images/title_pic.png" alt="" class="title_pic" />
    </a>
  </div>
</template>

<script>
export default {
  name: "TopBar",
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.top {
  width: 100%;
  overflow: hidden;
  .header {
    width: 100%;
    height: 98px;
    padding: 32px 0px 38px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      width: 100px;
      margin-right: 30px;
    }
    .title_pic {
      width: 700px;
    }
  }
}
</style>
